export default __webpack_public_path__ + "static/media/2023.0546663b.png";